import { render, staticRenderFns } from "./NotificationsArea.vue?vue&type=template&id=2acdd7ce"
import script from "./NotificationsArea.vue?vue&type=script&lang=js"
export * from "./NotificationsArea.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports